module.exports = __webpack_public_path__ + "media/images/Cata-10-15e9e3a57c0512ff6afb4b605c64ad57.jpg";